import { axiosClient, axiosClientWithToken } from "./api.client";
const apiTicket = {
    getTicketBySlug: async(slug) =>{
        try {
            const res = await axiosClient.get(`/ticket/slug/${slug}`,{ withCredentials: true });
            return res.data;
        } catch (error) {
            console.error('Error fetching', error); 
        }
    },

    getTicketByTicketId: async(id) =>{
        try {
            const res = await axiosClient.get(`/ticket/id/${id}`,{ withCredentials: true });
            return res.data;
        } catch (error) {
            console.error('Error fetching', error); 
        }
    }
}
export default apiTicket;